<template>
  <b-overlay
    variant="white"
    spinner-variant="primary"
    blur="0"
    opacity="1"
    rounded="sm"
    :show="show"
  >
    <slot />
  </b-overlay>
</template>

<script>
import { BOverlay } from 'bootstrap-vue'

export default {
  components: { BOverlay },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: undefined,
    },
  },
}
</script>

<style>

</style>
